module.exports = __webpack_public_path__ + "media/images/medium-d5583de0a62b6dc1b8a59a40fee4d499.jpg";